import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;
const BASE = API_KEEPER + "/sos/citizen-scheduled-visit";

const CitizenScheduledVisitService = {
    list: async (filter) => axios.post(BASE + "/list", filter).then(({data}) => data).catch((err) => { throw err }),

    get: async (id) => axios.get(BASE + "/" + id).then(({data}) => data).catch((err) => { throw err }),

    create: async (items) => axios.post(BASE, {items}).then(({data}) => data).catch((err) => { throw err }),

    edit: async (id, data) => axios.put(BASE + "/" + id, data).then(({data}) => data).catch((err) => { throw err }),

    cancel: async (id, reason) => axios.post(BASE + "/" + id + "/cancel", {reason}).catch((err) => { throw err }),

    execute: async (id, data) => axios.post(BASE + "/" + id + "/execution", data).then(({data}) => data).catch((err) => { throw err }),
};

export default CitizenScheduledVisitService;
